import React, { useContext, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const Navbar = () => {
  const { isAuthenticated, user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? 'hidden' : 'unset';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isMobileMenuOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isProfileDropdownOpen && !event.target.closest('.relative')) {
        setIsProfileDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isProfileDropdownOpen]);

  const authLinks = (
    <>
      <div className="hidden items-center gap-6 md:flex lg:gap-8">
        <div className="flex items-center gap-2 text-sm font-medium text-indigo-100 lg:gap-3">
          <Link to="/dashboard" className="inline-flex items-center gap-1.5 rounded-full border border-white/10 px-3 py-1.5 transition hover:bg-white/10 lg:px-4 lg:py-2">
            <i className="fas fa-home" aria-hidden></i>
            <span className="hidden xl:inline">Trang chủ</span>
          </Link>
          {user?.role === 'admin' && (
            <Link to="/admin" className="inline-flex items-center gap-1.5 rounded-full border border-white/10 px-3 py-1.5 transition hover:bg-white/10 lg:px-4 lg:py-2">
              <i className="fas fa-users-cog" aria-hidden></i>
              <span className="hidden xl:inline">Quản trị</span>
            </Link>
          )}
          <Link to="/calendar" className="inline-flex items-center gap-1.5 rounded-full border border-white/10 px-3 py-1.5 transition hover:bg-white/10 lg:px-4 lg:py-2">
            <i className="fas fa-calendar-alt" aria-hidden></i>
            <span className="hidden xl:inline">Lịch học</span>
          </Link>
          {user?.role === 'student' && (
            <>
              <Link to="/quizzes" className="inline-flex items-center gap-1.5 rounded-full border border-white/10 px-3 py-1.5 transition hover:bg-white/10 lg:px-4 lg:py-2">
                <i className="fas fa-tasks" aria-hidden></i>
                <span className="hidden xl:inline">Bài tập</span>
              </Link>
              <Link to="/custom-quizzes" className="inline-flex items-center gap-1.5 rounded-full border border-white/10 px-3 py-1.5 transition hover:bg-white/10 lg:px-4 lg:py-2">
                <i className="fas fa-edit" aria-hidden></i>
                <span className="hidden xl:inline">Tạo Bài Tập</span>
              </Link>
            </>
          )}
        </div>
        <div className="flex items-center gap-4">
          <div className="relative">
            <button
              onClick={() => setIsProfileDropdownOpen(!isProfileDropdownOpen)}
              className="flex items-center gap-3 rounded-full bg-white/10 px-4 py-2 backdrop-blur transition hover:bg-white/20"
            >
              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white/20">
                <i className="fas fa-user text-lg" aria-hidden></i>
              </div>
              <div className="text-left text-sm">
                <p className="font-semibold text-white">{user && user.name}</p>
                <p className="text-indigo-100">{user && (user.role === 'admin' ? 'Quản trị viên' : 'Sinh viên')}</p>
              </div>
              <i className="fas fa-chevron-down text-white/70" aria-hidden></i>
            </button>

            {isProfileDropdownOpen && (
              <div className="absolute right-0 mt-2 w-56 origin-top-right rounded-xl bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                <div className="py-2">
                  <Link
                    to="/profile"
                    onClick={() => setIsProfileDropdownOpen(false)}
                    className="flex items-center gap-3 px-4 py-2 text-sm text-slate-700 hover:bg-slate-50"
                  >
                    <i className="fas fa-user-cog" aria-hidden></i>
                    Thông tin cá nhân
                  </Link>
                  <Link
                    to="/help"
                    onClick={() => setIsProfileDropdownOpen(false)}
                    className="flex items-center gap-3 px-4 py-2 text-sm text-slate-700 hover:bg-slate-50"
                  >
                    <i className="fas fa-book" aria-hidden></i>
                    Hướng dẫn sử dụng
                  </Link>
                  {user?.role === 'student' && (
                    <Link
                      to="/feedback"
                      onClick={() => setIsProfileDropdownOpen(false)}
                      className="flex items-center gap-3 px-4 py-2 text-sm text-slate-700 hover:bg-slate-50"
                    >
                      <i className="fas fa-question-circle" aria-hidden></i>
                      Hỗ trợ
                    </Link>
                  )}
                  <div className="my-1 border-t border-slate-200"></div>
                  <button
                    onClick={() => {
                      handleLogout();
                      setIsProfileDropdownOpen(false);
                    }}
                    className="flex w-full items-center gap-3 px-4 py-2 text-left text-sm text-red-700 hover:bg-red-50"
                  >
                    <i className="fas fa-sign-out-alt" aria-hidden></i>
                    Đăng xuất
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <button
        className="relative z-20 inline-flex h-11 w-11 items-center justify-center rounded-full bg-white/10 text-white backdrop-blur transition hover:bg-white/20 md:hidden"
        onClick={toggleMobileMenu}
        aria-label="Toggle mobile menu"
      >
        <div className="flex h-5 w-6 flex-col justify-between">
          <span className={`h-0.5 w-full rounded-full bg-current transition ${isMobileMenuOpen ? 'translate-y-2 rotate-45' : ''}`}></span>
          <span className={`h-0.5 w-full rounded-full bg-current transition ${isMobileMenuOpen ? 'opacity-0' : ''}`}></span>
          <span className={`h-0.5 w-full rounded-full bg-current transition ${isMobileMenuOpen ? '-translate-y-2 -rotate-45' : ''}`}></span>
        </div>
      </button>
    </>
  );

  const guestLinks = (
    <>
      <div className="hidden items-center gap-4 md:flex">
        <Link to="/login" className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-sm font-semibold text-indigo-600 shadow-sm transition hover:bg-slate-100">
          <i className="fas fa-sign-in-alt" aria-hidden></i>
          Đăng nhập
        </Link>
      </div>

      <button
        className="relative z-20 inline-flex h-11 w-11 items-center justify-center rounded-full bg-white/10 text-white backdrop-blur transition hover:bg-white/20 md:hidden"
        onClick={toggleMobileMenu}
        aria-label="Toggle mobile menu"
      >
        <div className="flex h-5 w-6 flex-col justify-between">
          <span className={`h-0.5 w-full rounded-full bg-current transition ${isMobileMenuOpen ? 'translate-y-2 rotate-45' : ''}`}></span>
          <span className={`h-0.5 w-full rounded-full bg-current transition ${isMobileMenuOpen ? 'opacity-0' : ''}`}></span>
          <span className={`h-0.5 w-full rounded-full bg-current transition ${isMobileMenuOpen ? '-translate-y-2 -rotate-45' : ''}`}></span>
        </div>
      </button>
    </>
  );

  return (
    <nav className="fixed inset-x-0 top-0 z-40 bg-gradient-to-r from-indigo-700 via-violet-700 to-purple-700 text-white shadow-lg">
      <div className="mx-auto flex w-full items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        <Link to="/" className="flex items-center gap-3 rounded-full bg-white/10 px-4 py-2 text-left transition hover:bg-white/20">
          <div className="text-3xl" aria-hidden>
            <i className="fas fa-graduation-cap"></i>
          </div>
          <div>
            <p className="text-lg font-semibold leading-tight">EduSmart</p>
            <p className="text-xs text-indigo-100">Learning Management System</p>
          </div>
        </Link>

        {isAuthenticated ? authLinks : guestLinks}
      </div>

      {isMobileMenuOpen && (
        <div className="absolute inset-x-4 top-full z-10 mt-3 origin-top rounded-3xl bg-white/95 p-6 text-slate-800 shadow-2xl backdrop-blur md:hidden">
          {isAuthenticated ? (
            <div className="space-y-6">
              <div className="flex items-center gap-3">
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-indigo-100 text-indigo-600">
                  <i className="fas fa-user text-lg" aria-hidden></i>
                </div>
                <div>
                  <p className="text-base font-semibold text-slate-900">{user && user.name}</p>
                  <p className="text-sm text-slate-500">{user && (user.role === 'admin' ? 'Quản trị viên' : 'Sinh viên')}</p>
                </div>
              </div>

              <div className="space-y-3">
                <button
                  className="w-full rounded-xl bg-slate-100 px-4 py-3 text-left text-sm font-medium text-slate-700 transition hover:bg-indigo-50 hover:text-indigo-600"
                  onClick={() => {
                    navigate('/dashboard');
                    closeMobileMenu();
                  }}
                >
                  <i className="fas fa-home mr-3" aria-hidden></i>
                  Trang chủ
                </button>
                {user?.role === 'admin' && (
                  <button
                    className="w-full rounded-xl bg-slate-100 px-4 py-3 text-left text-sm font-medium text-slate-700 transition hover:bg-indigo-50 hover:text-indigo-600"
                    onClick={() => {
                      navigate('/admin');
                      closeMobileMenu();
                    }}
                  >
                    <i className="fas fa-users-cog mr-3" aria-hidden></i>
                    Quản trị
                  </button>
                )}
                <button
                  className="w-full rounded-xl bg-slate-100 px-4 py-3 text-left text-sm font-medium text-slate-700 transition hover:bg-indigo-50 hover:text-indigo-600"
                  onClick={() => {
                    navigate('/calendar');
                    closeMobileMenu();
                  }}
                >
                  <i className="fas fa-calendar-alt mr-3" aria-hidden></i>
                  Lịch học
                </button>
                {user?.role === 'student' && (
                  <>
                    <button
                      className="w-full rounded-xl bg-slate-100 px-4 py-3 text-left text-sm font-medium text-slate-700 transition hover:bg-indigo-50 hover:text-indigo-600"
                      onClick={() => {
                        navigate('/quizzes');
                        closeMobileMenu();
                      }}
                    >
                      <i className="fas fa-tasks mr-3" aria-hidden></i>
                      Bài tập
                    </button>
                    <button
                      className="w-full rounded-xl bg-slate-100 px-4 py-3 text-left text-sm font-medium text-slate-700 transition hover:bg-indigo-50 hover:text-indigo-600"
                      onClick={() => {
                        navigate('/custom-quizzes');
                        closeMobileMenu();
                      }}
                    >
                      <i className="fas fa-edit mr-3" aria-hidden></i>
                      Tạo Bài Tập
                    </button>
                  </>
                )}
              </div>

              <div className="space-y-3 pt-4 border-t border-slate-200">
                <button
                  className="w-full rounded-xl bg-slate-100 px-4 py-3 text-left text-sm font-medium text-slate-700 transition hover:bg-indigo-50 hover:text-indigo-600"
                  onClick={() => {
                    navigate('/profile');
                    closeMobileMenu();
                  }}
                >
                  <i className="fas fa-user-cog mr-3" aria-hidden></i>
                  Thông tin cá nhân
                </button>
                <button
                  className="w-full rounded-xl bg-slate-100 px-4 py-3 text-left text-sm font-medium text-slate-700 transition hover:bg-indigo-50 hover:text-indigo-600"
                  onClick={() => {
                    navigate('/help');
                    closeMobileMenu();
                  }}
                >
                  <i className="fas fa-book mr-3" aria-hidden></i>
                  Hướng dẫn sử dụng
                </button>
                {user?.role === 'student' && (
                  <button
                    className="w-full rounded-xl bg-slate-100 px-4 py-3 text-left text-sm font-medium text-slate-700 transition hover:bg-indigo-50 hover:text-indigo-600"
                    onClick={() => {
                      navigate('/feedback');
                      closeMobileMenu();
                    }}
                  >
                    <i className="fas fa-question-circle mr-3" aria-hidden></i>
                    Hỗ trợ
                  </button>
                )}
              </div>

              <button
                onClick={() => {
                  handleLogout();
                  closeMobileMenu();
                }}
                className="w-full rounded-xl bg-indigo-600 px-4 py-3 text-sm font-semibold text-white shadow transition hover:bg-indigo-700"
              >
                <i className="fas fa-sign-out-alt mr-3" aria-hidden></i>
                Đăng xuất
              </button>
            </div>
          ) : (
            <div className="space-y-3">
              <button
                className="w-full rounded-xl bg-indigo-600 px-4 py-3 text-sm font-semibold text-white shadow transition hover:bg-indigo-700"
                onClick={() => {
                  navigate('/login');
                  closeMobileMenu();
                }}
              >
                <i className="fas fa-sign-in-alt mr-3" aria-hidden></i>
                Đăng nhập
              </button>
            </div>
          )}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
